import React from 'react';
import { Alert } from 'react-bootstrap';

import { __ } from '../../../../helpers/translations';
import { useAuthContext } from '../../../../hooks/useAuthContext';
import ContentSection from '../../common/ContentSection';
import Page from '../../common/Page';
import SignedOut from '../../common/SignedOutDialog';
import SelectTemplateModal from '../components/SelectTemplateModal';

export default function SelectTemplate() {
  const { user } = useAuthContext();

  if (!user) {
    return <SignedOut />;
  }

  return (
    <Page>
      <ContentSection>
        {user.email.endsWith('@monash.edu') && (
          <Alert variant="danger" className="text-center">
            {__('G302')}
            <br />
            <a href="https://monash.itpmetrics.com" rel="noopener noreferrer">
              https://monash.itpmetrics.com
            </a>
          </Alert>
        )}
        <SelectTemplateModal />
        <br />
      </ContentSection>
    </Page>
  );
}
